
<template>
  <v-dialog
    v-model="innerVal"
    max-width="800px"
    style="overflow: hidden;"
  >
    <v-card style="overflow: hidden;" height="90vh">
      <iframe
        width="100%"
        height="100%"
        :src="link"
        :title="title"
        scrolling="no"
      ></iframe>
      <!-- Cancel Btn -->
      <v-btn
        color="grey lighten-1"
        icon
        small
        @click="cancelAction"
        style="position: absolute; left: 5px; top: 12px;"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DocumentFrame',

    props: {
      value: { type:Boolean, default:false },
      link: { type:String, default:'' },
      title: { type:String, default:'' }
    },

    data() {
      return {
        innerVal: this.value
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      cancelAction() {
        this.innerVal = false
      }
    }
  }
</script>

<style lang="scss" scoped>
iframe {
    overflow: hidden;
}
</style>